import { useMatch } from 'react-router-dom'

const useIsMobileReferral = () => {
  const match = useMatch('mobile/*')
  return match?.pathname?.includes('/mobile')
}

export default useIsMobileReferral
